export function formateNum(num: any) {
    if(num===undefined){
        return '--'
    }
    let str = String(num);
    let strStart = str, strEnd = ''
    if (str.indexOf('.') != -1) {
        strStart = str.split('.')[0];
        strEnd = str.split('.')[1];
    }
    let len = strStart.length;
    let count = 0;
    let newStr = ''
    for (let i = len - 1; i >= 0; i--) {
        if (count % 3 == 0 && count != 0) {
            newStr = strStart[i] + ',' + newStr
        } else {
            newStr = strStart[i] + newStr;
        }
        count++;
    }
    if (strEnd) {
        newStr = newStr + '.' + strEnd;
    }
    return newStr;
}

export function formatNumber(
    num: string | number | undefined,
    options: {
      decimals?: number;
      fixedDecimals?: boolean;
      withSplit?: boolean;
      toReadable?: boolean;
      roundMode?: "round" | "floor" | "ceil";
    } = {}
  ) {
    if (num === undefined || num === "") {
      return "--";
    }
    if (isNaN(Number(num))) {
      return "--";
    }
  
    let decimals = options.decimals === undefined ? 6 : options.decimals;
    const withSplit = options.withSplit === undefined ? true : options.withSplit;
    const fixedDecimals =
      options.fixedDecimals === undefined ? true : options.fixedDecimals;
    const toReadable =
      options.toReadable === undefined ? true : options.toReadable;
    const roundMode = options.roundMode || "floor";
    let suffix = "";
  
    let newNum = "0";
    if (toReadable && Number(num) > 1000000) {
      newNum = Number(num) / 1000000 + "";
      suffix = "M";
      decimals = 2;
    } else if (toReadable && Number(num) > 1000) {
      newNum = Number(num) / 1000 + "";
      suffix = "K";
      decimals = 2;
    } else {
      newNum = num + "";
    }
  
    const roundMethod =
      roundMode === "floor"
        ? Math.floor
        : roundMode === "ceil"
        ? Math.ceil
        : Math.round;
  
    newNum =
      roundMethod(Number(newNum) * Math.pow(10, decimals)) /
        Math.pow(10, decimals) +
      "";
  
    if (fixedDecimals) {
      newNum = Number(newNum).toFixed(decimals);
    }
  
    if (withSplit) {
      var parts = newNum.split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".") + suffix;
    } else {
      return newNum + suffix;
    }
  }


  export const echartslineColor=["#0095EB","#20604F","#268785","#255359","#7DB9DE","#4E4F97","#8F77B5","#E03C8A","#6A4C9C","#F596AA","#EB7A77","#F17C67","#CC543A","#E1A679","#DAC9A6","#828282"]

 
